<template>
  <div class="page-table scrollable only-y">
    <div class="no-table-box page-header">
      <el-row class="hidden-sm-and-up pb-15">
        <h1>
          <v-svg class="voxo-green" sprite="clock" />
          Time of Days
        </h1>
      </el-row>
      <el-row class="hidden-xs-only pb-15">
        <el-col :span="12">
          <h1>
            <v-svg class="voxo-green" sprite="clock" />
            Time of days
          </h1>
        </el-col>

        <el-col class="text-right" :span="12">
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px" />
            Total: {{ total }}
          </el-tag>
        </el-col>
      </el-row>

      <div class="flex pb-20">
        <div class="box">
          <el-input
            class="mr-10"
            v-model="search"
            placeholder="Search"
            clearable
            style="max-width: 220px"
          />

          <el-select
            v-model="typeFilter"
            @change="filterByType"
            style="max-width: 160px"
            class="hidden-xs-only"
          >
            <el-option value="all" label="All" />
            <el-option value="general" label="General" />
            <el-option value="business" label="Business Hour" />
          </el-select>

          <el-button class="ml-10 hidden-xs-only" @click="doExport">
            Export
          </el-button>
        </div>
        <div class="box right">
          <el-dropdown>
            <el-button>
              Add New
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="openCreate('regular')">
                <v-svg class="success-text" sprite="clock" />
                General
              </el-dropdown-item>
             <el-dropdown-item @click.native="openCreate('business')">
                <v-svg class="voxo-orange" sprite="clock" />
                Business Hour
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>

    <create-form
      :createVisible="createRegularVisible"
      :createProcessing="createProcessing"
      :clearFormFields="clearFormFields"
      :timezones="timezones"
      :customTypeOptions="customTypeOptions"
      :globalConditionOptions="globalConditionOptions"
      :conditionOptions="conditionOptions"
      :draggableDestTypes="draggableDestTypes"
      :weekTimeOfDayOptions="weekTimeOfDayOptions"
      :branch-options="branchOptions"
      @createOperation="createOperation"
      @cancelOperation="cancelOperation"
    />

    <edit-form
      :draggableDestTypes="draggableDestTypes"
      :editVisible="editRegularVisible"
      :editProcessing="editProcessing"
      :clearFormFields="clearFormFields"
      :timezones="timezones"
      :customTypeOptions="customTypeOptions"
      :globalConditionOptions="globalConditionOptions"
      :conditionOptions="conditionOptions"
      :selectedTimeOfDay="selectedTimeOfDay"
      :weekTimeOfDayOptions="weekTimeOfDayOptions"
      :branch-options="branchOptions"
      @editOperation="editOperation"
      @cancelOperation="cancelOperation"
    />

    <business-hours-form
      :timezones="timezones"
      :context="businessFormContext"
      :visible="businessFormVisible"
      :selectedRecordId="businessFormRecordId"
      :draggableDestTypes="draggableDestTypes"
      @cancelOperation="cancelOperation"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { debounce } from "lodash";
import { ExportToCsv } from "export-to-csv";
import EditForm from "./components/editForm";
import CreateForm from "./components/createForm";
import { globalEventBus } from "../../../globalEventBus";
import feathersClient from "../../../feathers/feathers-client";
import BusinessHoursForm from "./components/businessHoursForm.vue";
import { deleteBusinessHour } from "@/api/business-hours/methods.js";

export default {
  name: "TimeOfDaysTable",

  components: {
    CreateForm,
    EditForm,
    BusinessHoursForm,
  },

  data() {
    return {
      typeFilter: "all",
      draggableDestTypes: [
        "SPECIAL",
        "CUSTOM",
        "IVR",
        "VOICEMAIL",
        "PLAYBACK",
        "HUNTLIST",
        "EXT",
        "QUEUE",
        "SMS",
        "MUSICONHOLD",
        "CONDITION",
      ],
      conditionsChannel: null,
      createProcessing: false,
      editProcessing: false,
      deleteProcessing: false,
      tableLoading: false,
      tableData: [],
      allConditions: [],
      search: "",
      editRegularVisible: false,
      createRegularVisible: false,
      businessFormVisible: false,
      clearFormFields: false,
      visibleActionsId: "",
      selectedTimeOfDay: null,
      timezones: [],
      globalConditionOptions: [],
      didOptions: [],
      didQuery: "",
      branchOptions: [],
      total: 0,
      customTypeOptions: [
        {
          label: "All listed conditions satisfied",
          value: "ALL",
        },
        {
          label: "Any listed conditions satisfied",
          value: "ANY",
        },
        {
          label: "Calendar",
          value: "CALENDAR",
        },
        {
          label: "Use global",
          value: "USEGLOBAL",
        },

        {
          label: "Weektime",
          value: "WEEKTIME",
        },
      ],
      tableColumns: [
        {
          field: "sprite",
          title: "",
          width: 50,
          slots: {
            default: () => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-green" sprite="clock" />
                </div>,
              ];
            },
          },
        },
        {
          field: "name",
          title: "Name",
          minWidth: 150,
          sortable: true,
        },
        {
          field: "type",
          title: "Type",
          minWidth: 150,
          sortable: true,
        },
        {
          field: "override",
          title: "",
          width: 50,
          slots: {
            default: ({ row }) => {
              return [
                <el-tooltip
                  placement="top"
                  content="Override active"
                  v-show={!!row.param4}
                  style="font-size: 16px;"
                >
                  <i class="el-icon-warning voxo-orange"></i>
                </el-tooltip>,
              ];
            },
          },
        },
        {
          field: "actions",
          title: "",
          minWidth: "150",
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-button
                    id={"edit-" + row.id}
                    icon="el-icon-edit"
                    onClick={() => this.openEditModal(row)}
                    class="table-action-button icon-blue"
                  />
                  <el-button
                    id={"delete-" + row.id}
                    icon="el-icon-delete"
                    onClick={() => this.deleteOperation(row)}
                    class="table-action-button icon-red"
                  />
                </div>,
              ];
            },
          },
        },
      ],

      weekTimeOfDayOptions: [],

      // Business Hour
      businessFormContext: "Create",
      businessFormRecordId: null,
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    user() {
      return this.$store.state.auth.user;
    },

    conditionOptions() {
      return [...this.tableData, ...this.globalConditionOptions];
    },
  },

  watch: {
    selectedTenant() {
      this.findConditions();
      this.queryBranches();
      feathersClient
        .service("channel-memberships")
        .remove(null, { query: { channelName: this.conditionsChannel } });
      this.joinSocketChannel();
    },
    user() {
      this.getTimezoneOptions();
      this.queryBranches();
      this.findConditions();
      if (!this.conditionsChannel) {
        this.joinSocketChannel();
      }
    },
    search: debounce(function () {
      this.searchConditions();
    }, 500),
  },

  methods: {
    ...mapActions("conditions", {
      deleteConditions: "remove",
      createConditions: "create",
      patchConditions: "patch",
    }),

    filterByType(val) {
      if (this.search.length) {
        this.searchConditions();
      } else {
        switch (val) {
          case "all":
            this.tableData = [...this.allConditions];
            break;
          case "general":
            this.tableData = this.allConditions.filter(
              (item) => item.type !== "BUSINESSHOUR"
            );
            break;
          case "business":
            this.tableData = this.allConditions.filter(
              (item) => item.type === "BUSINESSHOUR"
            );
            break;
          default:
            this.tableData = [...this.allConditions];
            break;
        }
      }
      this.total = this.tableData.length;
    },

    doExport() {
      const data = [...this.tableData];
      if (data.length) {
        const writeData = data.map((item) => ({
          name: item.name,
          type: item.type,
        }));

        const options = {
          filename: "time_of_days",
          showLabels: true,
          headers: ["Name", "Type"],
        };

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(writeData);
      }
    },
    queryBranches() {
      this.branchOptions = [];
      feathersClient
        .service("branches")
        .find({
          query: {
            tenantId: this.selectedTenant.id,
            $sort: { name: 1 },
          },
        })
        .then((res) => {
          this.branchOptions = [...res];
        }).catch( () => {
          this.branchOptions = [];
      });
    },

    searchConditions() {
      if (this.search.length) {
        this.tableData = this.allConditions.filter(
          (data) =>
            data.name.toLowerCase().includes(this.search.toLowerCase()) ||
            data.type.toLowerCase().includes(this.search.toLowerCase())
        );
      } else {
        this.tableData = [...this.allConditions];
      }
      this.total = this.tableData.length;
    },

    //General Form and Table Operations
    openCreate(type) {
      if (type === "regular") {
        this.createRegularVisible = true;
      }

      if (type === "business") {
        this.businessFormContext = "Create";
        this.businessFormVisible = true;
      }

      this.clearFormFields = false;
    },

    openEditModal(row) {
      this.clearFormFields = false;
      this.businessFormRecordId = null;

      if (row.type === "BUSINESSHOUR") {
        this.businessFormContext = "Edit";
        this.businessFormRecordId = row.id;
        this.businessFormVisible = true;
        return;
      }

      this.tableLoading = true;
      feathersClient
        .service("conditions")
        .get(row.id)
        .then((res) => {
          this.tableLoading = false;
          this.selectedTimeOfDay = res;
          this.editRegularVisible = true;
        });
    },

    cellClicked(data) {
      if (data.column.property !== "actions") {
        this.openEditModal(data.row);
      }
    },

    rowHover(data) {
      this.visibleActionsId = data.row.id;
    },

    rowLeave() {
      this.visibleActionsId = "";
    },

    createOperation(params) {
      const createBody = { ...params };

      this.$confirm("Process time of day create?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          this.createProcessing = true;
          this.createConditions(createBody)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Created successfully!",
                type: "success",
              });
              this.createProcessing = false;
              this.clearFormFields = true;
              this.cancelOperation();
            })
            .catch((error) => {
              this.clearFormFields = false;

              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error",
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error",
                });
              }

              this.createProcessing = false;
            });
        })
        .catch(() => true);
    },

    editOperation(editBody) {
      this.$confirm("Process time of day edit?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          this.editProcessing = true;

          this.patchConditions([this.selectedTimeOfDay.id, editBody])
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Edited successfully!",
                type: "success",
              });
              this.editProcessing = false;
              this.clearFormFields = true;
              this.cancelOperation();
            })
            .catch((error) => {
              this.clearFormFields = false;

              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error",
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error",
                });
              }
              this.editProcessing = false;
            });
        })
        .catch(() => true);
    },

    cancelOperation() {
      this.didQuery = "";
      this.clearFormFields = true;

      this.editRegularVisible = false;
      this.createRegularVisible = false;
      this.businessFormVisible = false;
      this.businessFormRecordId = null;
      this.findConditions();
    },

    async deleteOperation(row) {
      if (row.type === "BUSINESSHOUR") {
        try {
          await this.$confirm("Process business hour delete?", "Warning", {
            confirmButtonText: "Yes",
            cancelButtonText: "Cancel",
          });

          this.deleteProcessing = true;
          const { success, data } = await deleteBusinessHour({ id: row.id });
          this.deleteProcessing = false;

          if (success) {
            this.findConditions();
          }
        } catch (err) {
          this.deleteProcessing = false;
        }
        return;
      }

      this.$confirm("Process time of day delete?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          this.deleteProcessing = true;

          this.deleteConditions(row.id)
            .then(() => {
              this.deleteProcessing = false;
              this.$notify({
                title: "Success",
                message: "Deleted successfully!",
                type: "success",
              });
            })
            .catch((error) => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error",
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error",
                });
              }
              this.deleteProcessing = false;
            });
        })
        .catch(() => true);
    },

    getTimezoneOptions() {
      feathersClient
        .service("timezones")
        .find({
          query: {
            $sort: {
              description: 1,
            },
          },
        })
        .then((res) => {
          this.timezones = res;
        });
    },

    findConditions() {
      this.tableLoading = true;
      this.tableData = [];
      feathersClient
        .service("conditions")
        .find({
          query: {
            tenantId: { $in: [0, this.selectedTenant.id] },
            type: { $ne: "AMD" },
            $sort: { name: 1 },
          },
        })
        .then((res) => {
          this.globalConditionOptions = res
            .filter(
              (item) =>
                item.tenantId === 0 ||
                item.tenantId === this.selectedTenant.partnerTenantId
            )
            .map((item) => ({
              ...item,
              isPartner: item.tenantId === this.selectedTenant.partnerTenantId,
            }));
          this.weekTimeOfDayOptions = res
            .filter((item) => item.type === "CALENDAR")
            .map((item) => ({
              ...item,
              isPartner: item.tenantId === this.selectedTenant.partnerTenantId,
            }));
          this.tableData = res.filter(
            (item) => item.tenantId === this.selectedTenant.id
          );
          this.allConditions = [...this.tableData];
          this.filterByType(this.typeFilter);

          this.total = this.tableData.length;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },

    joinSocketChannel() {
      const channelService = feathersClient.service("channel-memberships");
      const data = {
        roomType: "admins",
        tenantId: this.selectedTenant.id,
      };
      channelService.create(data).then(() => {
        this.conditionsChannel = `${data.roomType}/${data.tenantId}`;
      });
    },

    removeListeners() {
      feathersClient.service("conditions").removeListener("patched");
      feathersClient.service("conditions").removeListener("created");
      feathersClient.service("conditions").removeListener("removed");
      globalEventBus.$off("appReconnected");
    },
  },
  created() {
    //event listeners
    //monitor socket connection and reconnect to channel
    globalEventBus.$on("appReconnected", () => {
      this.joinSocketChannel();
    });

    if (this.user) {
      this.tableLoading = true;
      this.queryBranches();
    }

    //record was edited
    //always refresh did destination options
    feathersClient.service("conditions").on("patched", (data) => {
      const updateIndex = this.tableData.findIndex(
        (item) => item.id === data.id
      );
      const updateAllIndex = this.allConditions.findIndex(
        (item) => item.id === data.id
      );
      if (updateIndex >= 0) {
        this.tableData.splice(updateIndex, 1, data);
      }
      if (updateAllIndex >= 0) {
        this.allConditions.splice(updateAllIndex, 1, data);
      }
    });

    //record was created
    feathersClient.service("conditions").on("created", (data) => {
      this.tableData.push(data);
      this.allConditions.push(data);
    });

    //record was deleted
    feathersClient.service("conditions").on("removed", (data) => {
      const indexToRemove = this.tableData.findIndex(
        (item) => item.id === data.id
      );
      const indexAllToRemove = this.allConditions.findIndex(
        (item) => item.id === data.id
      );
      if (indexToRemove >= 0) {
        this.tableData.splice(indexToRemove, 1);
      }
      if (indexAllToRemove >= 0) {
        this.allConditions.splice(indexAllToRemove, 1);
      }
    });
  },
  mounted() {
    if (this.user) {
      this.joinSocketChannel();
      this.getTimezoneOptions();
      this.findConditions();
    }
  },
  beforeDestroy() {
    feathersClient
      .service("channel-memberships")
      .remove(null, { query: { channelName: this.conditionsChannel } });
    this.removeListeners();
  },
};
</script>
